import { Draft } from "@reduxjs/toolkit";
import { State as DataState } from "./data";
import { WeekType } from "../modal/ConsultationModals/Content/modal";
import { DayProps } from "../modal/ConsultationModals/Content/Day";
import {
    getCurrentWeek,
    has53Weeks,
} from "../calendar/carouselCalendar/legacyUtils";
import _set from "lodash/set";
import _setWith from "lodash/setWith";

export const getEvenOdd = (week: number): WeekType =>
    week % 2 === 0 ? "even" : "odd";

const copyFromRegularToIndividuals = (
    state: Draft<DataState>,
    day: DayProps
) => {
    if (!day.isRegular) {
        return;
    }

    const regularWeekSettings = state.calendarData.regularWeekSettings;
    const individualWeekSettings = state.calendarData.individualWeekSettings;
    const oddWeekUsed = regularWeekSettings.oddWeekUsed;

    const consultations = regularWeekSettings[day.weekType][day.index];

    const currentWeek = getCurrentWeek();
    const currentYear = new Date().getFullYear();

    let _weekNumbers = 52;

    if (has53Weeks(currentYear)) {
        _weekNumbers = 53;
    }

    for (let week = 1; week <= _weekNumbers; week++) {
        // Iterate through 52 weeks from current one
        const year = week >= currentWeek ? currentYear : currentYear + 1;

        if (oddWeekUsed && getEvenOdd(week) !== day.weekType) {
            continue;
        }

        if (!consultations) {
            delete individualWeekSettings?.[year]?.[week]?.[day.index];

            continue;
        }

        _setWith(
            individualWeekSettings,
            [year, week, day.index],
            consultations,
            Object
        );

        // _set(individualWeekSettings, [year, week, day.index], consultations);
    }
};

export default copyFromRegularToIndividuals;
